import { Box, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

export function PublicLayout() {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        background:
          "linear-gradient(135deg, #005AA9 0%, #1E88E5 35%, #FF8F45 65%, #FF5F00 100%)",
        overflow: "hidden",
      }}
    >
      {/* Dalakraft text */}
      <Box
        sx={{
          position: "absolute",
          top: 40,
          left: 40,
          opacity: 0.9,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            fontWeight: "light",
            textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          Dalakraft
        </Typography>
      </Box>

      {/* Kraftvyn B2B text */}
      <Box
        sx={{
          position: "absolute",
          bottom: 40,
          left: 40,
          opacity: 0.9,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            fontWeight: "light",
            textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          Kraftvyn B2B
        </Typography>
      </Box>

      {/* Enkla Elbolaget text */}
      <Box
        sx={{
          position: "absolute",
          bottom: 40,
          right: 40,
          opacity: 0.9,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            fontWeight: "light",
            textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          Enkla Elbolaget
        </Typography>
      </Box>

      <Outlet />
    </Box>
  );
}
